module.exports = __webpack_public_path__ + "2dec2c5e4e59c41796770a056687ddfd.fbx";